// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-we-work-page {
  width: 100%;
  min-height: 100vh;
  background: #121212;
  color: #f1f1f1;
  font-family: "Satoshi", sans-serif;
}

.how-we-work-section {
  width: 100%;
  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);
  max-width: 1200px;
  margin: 0 auto;
}

.how-we-work-title {
  text-align: center;
  font-size: clamp(36px, 4.5vw, 48px);
  font-weight: 600;
  margin: 0 0 64px;
  color: #f1f1f1;
  line-height: 1.2;
}

.how-we-work-cards {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
}

.how-we-work-card-wrapper {
  display: flex;
  align-items: center;
  gap: 0;
  flex: 1 1 auto;
}

.how-we-work-card {
  flex: 1 1;
  min-width: 0;
  padding: 32px 24px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: border-color 0.25s ease, box-shadow 0.25s ease;
}

.how-we-work-card:hover {
  border-color: rgba(255, 255, 255, 0.18);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.how-we-work-number {
  display: block;
  font-size: clamp(2rem, 3vw, 3rem);
  font-weight: 700;
  color: #ccff00;
  line-height: 1;
  margin-bottom: 16px;
  letter-spacing: -0.02em;
}

.how-we-work-card-title {
  font-size: clamp(20px, 2vw, 24px);
  font-weight: 600;
  color: #f1f1f1;
  margin: 0 0 12px;
  line-height: 1.3;
}

.how-we-work-card-description {
  font-size: clamp(14px, 1.2vw, 16px);
  line-height: 1.6;
  color: #a0a0a0;
  margin: 0 0 20px;
}

.how-we-work-deliverable {
  margin-top: auto;
}

.how-we-work-deliverable-label {
  color: #ccff00;
  font-size: 14px;
  font-weight: 600;
  margin-right: 6px;
}

.how-we-work-deliverable-text {
  color: #a0a0a0;
  font-size: 14px;
  line-height: 1.5;
}

.how-we-work-arrow {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  color: rgba(255, 255, 255, 0.35);
}

/* Desktop: horizontal row with arrows between cards */
@media (min-width: 1024px) {
  .how-we-work-cards {
    flex-direction: row;
    align-items: stretch;
    gap: 0;
  }

  .how-we-work-card-wrapper {
    flex: 1 1;
    flex-direction: row;
    align-items: stretch;
    gap: 0;
    min-width: 0;
  }

  .how-we-work-card {
    flex: 1 1;
    min-height: 280px;
    display: flex;
    flex-direction: column;
  }

  .how-we-work-arrow {
    align-self: center;
    padding: 0 8px;
    flex-shrink: 0;
  }
}

/* Tablet: optional 2-col or keep stacked with horizontal arrows */
@media (min-width: 768px) and (max-width: 1023px) {
  .how-we-work-cards {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
  }

  .how-we-work-card-wrapper {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 12px);
    max-width: calc(50% - 12px);
    flex-direction: column;
  }

  .how-we-work-arrow {
    display: none;
  }

  .how-we-work-card-wrapper:nth-child(3) {
    flex: 1 1 100%;
    max-width: 100%;
  }
}

@media (max-width: 767px) {
  .how-we-work-arrow {
    transform: rotate(-90deg);
    padding: 8px 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/how-we-work/how-we-work.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gCAAgC;AAClC;;AAEA,sDAAsD;AACtD;EACE;IACE,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;EACR;;EAEA;IACE,SAAW;IACX,mBAAmB;IACnB,oBAAoB;IACpB,MAAM;IACN,YAAY;EACd;;EAEA;IACE,SAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,cAAc;EAChB;AACF;;AAEA,kEAAkE;AAClE;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;IAC1B,2BAA2B;IAC3B,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,cAAc;EAChB;AACF","sourcesContent":[".how-we-work-page {\n  width: 100%;\n  min-height: 100vh;\n  background: #121212;\n  color: #f1f1f1;\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.how-we-work-section {\n  width: 100%;\n  padding: clamp(60px, 8vw, 120px) 24px clamp(80px, 10vw, 96px);\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.how-we-work-title {\n  text-align: center;\n  font-size: clamp(36px, 4.5vw, 48px);\n  font-weight: 600;\n  margin: 0 0 64px;\n  color: #f1f1f1;\n  line-height: 1.2;\n}\n\n.how-we-work-cards {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0;\n}\n\n.how-we-work-card-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  flex: 1 1 auto;\n}\n\n.how-we-work-card {\n  flex: 1 1 0;\n  min-width: 0;\n  padding: 32px 24px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  transition: border-color 0.25s ease, box-shadow 0.25s ease;\n}\n\n.how-we-work-card:hover {\n  border-color: rgba(255, 255, 255, 0.18);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n}\n\n.how-we-work-number {\n  display: block;\n  font-size: clamp(2rem, 3vw, 3rem);\n  font-weight: 700;\n  color: #ccff00;\n  line-height: 1;\n  margin-bottom: 16px;\n  letter-spacing: -0.02em;\n}\n\n.how-we-work-card-title {\n  font-size: clamp(20px, 2vw, 24px);\n  font-weight: 600;\n  color: #f1f1f1;\n  margin: 0 0 12px;\n  line-height: 1.3;\n}\n\n.how-we-work-card-description {\n  font-size: clamp(14px, 1.2vw, 16px);\n  line-height: 1.6;\n  color: #a0a0a0;\n  margin: 0 0 20px;\n}\n\n.how-we-work-deliverable {\n  margin-top: auto;\n}\n\n.how-we-work-deliverable-label {\n  color: #ccff00;\n  font-size: 14px;\n  font-weight: 600;\n  margin-right: 6px;\n}\n\n.how-we-work-deliverable-text {\n  color: #a0a0a0;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.how-we-work-arrow {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 12px;\n  color: rgba(255, 255, 255, 0.35);\n}\n\n/* Desktop: horizontal row with arrows between cards */\n@media (min-width: 1024px) {\n  .how-we-work-cards {\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0;\n  }\n\n  .how-we-work-card-wrapper {\n    flex: 1 1 0;\n    flex-direction: row;\n    align-items: stretch;\n    gap: 0;\n    min-width: 0;\n  }\n\n  .how-we-work-card {\n    flex: 1 1 0;\n    min-height: 280px;\n    display: flex;\n    flex-direction: column;\n  }\n\n  .how-we-work-arrow {\n    align-self: center;\n    padding: 0 8px;\n    flex-shrink: 0;\n  }\n}\n\n/* Tablet: optional 2-col or keep stacked with horizontal arrows */\n@media (min-width: 768px) and (max-width: 1023px) {\n  .how-we-work-cards {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 24px;\n  }\n\n  .how-we-work-card-wrapper {\n    flex: 1 1 calc(50% - 12px);\n    max-width: calc(50% - 12px);\n    flex-direction: column;\n  }\n\n  .how-we-work-arrow {\n    display: none;\n  }\n\n  .how-we-work-card-wrapper:nth-child(3) {\n    flex: 1 1 100%;\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 767px) {\n  .how-we-work-arrow {\n    transform: rotate(-90deg);\n    padding: 8px 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
